import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {PaginationModel} from '../../models/file-table.model';
import {Router} from '@angular/router';

@Component({
    selector: 'app-component-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {

    @Input('pagination') public pagination: PaginationModel = {
        current_page: 1,
        limit: 50,
        pages: 1,
    };
    @Input('totalPages') public totalPages: number;
    @Output('page') public page: EventEmitter<number> = new EventEmitter<number>();

    public pages: any;

    constructor(
        public router: Router,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setPages();
    }

    setPages(): void {
        this.pages = [];
        if (!this.pagination.pages) {
            this.pagination.pages = 1;
        }

        let page = 0;
        while (page < this.pagination.pages) {
            page++;
            this.pages.push(page);
        }
    }

    prev(): void {
        this.page.emit(
            this.pagination.current_page !== 1 ?
                this.pagination.current_page = this.pagination.current_page - 1 : this.pagination.current_page
        );
    }

    next(): void {
        this.page.emit(
            this.pagination.current_page < this.pages.length ?
                this.pagination.current_page = this.pagination.current_page + 1 : this.pagination.current_page
        );
    }

    async setPage(item: number): Promise<any> {
        this.page.emit(
            this.pagination.current_page = item
        );
    }
}

